import React from 'react';
import PropTypes from 'prop-types';
import { verificationEntityType } from 'constants/verificationEntityType';
import { Box, Grid } from '@mui/material';
import { IconButton, Typography } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { isDirty } from '@totalsoft/change-tracking';
import { Prompt } from 'react-router-dom';
import { Icon } from 'components/common/CommonStyles';

const FolderExternalChecksItemSummaryComponent = ({ check, expanded, index, dirtyInfo, onSave, saving, decisionExternalChecksWrite }) => {
  const [t] = useTranslation();

  const title = (
    <Box display='flex' gap={1} alignItems='center'>
      <Typography color='textPrimary' variant='subtitle1'>
        {check.verificationName}{' '}
        {(check.entityType === verificationEntityType.partner && t('Folder.VerificationsSummary.ForPartner')) ||
          (check.entityType === verificationEntityType.item && t('Folder.VerificationsSummary.ForAsset'))}
      </Typography>
      <Typography variant='subtitle1' fontWeight='bold'>
        {check.entityName}
      </Typography>
    </Box>
  );

  return (
    <Grid container alignItems='center' justifyContent='space-between'>
      <Prompt when={isDirty(dirtyInfo)} message={() => t('LeavingWithoutSaving')} />
      {title}
      {expanded && (
        <IconButton
          size='tiny'
          onClick={e => onSave(e, check.result)}
          id={`folder_decision_externalChecksCard_list_${index}_saveBtn`}
          disabled={!isDirty(dirtyInfo) || saving || !decisionExternalChecksWrite}
          color='primary'
          tooltip={t('Folder.VerificationsSummary.SaveResult')}
          variant='text'
        >
          <Icon>save</Icon>
        </IconButton>
      )}
    </Grid>
  );
};

FolderExternalChecksItemSummaryComponent.propTypes = {
  check: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  dirtyInfo: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  decisionExternalChecksWrite: PropTypes.bool.isRequired
};

export default FolderExternalChecksItemSummaryComponent;
